import { render, staticRenderFns } from "./AddMembersDialog.vue?vue&type=template&id=20cf8c46&scoped=true&"
import script from "./AddMembersDialog.vue?vue&type=script&lang=ts&"
export * from "./AddMembersDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cf8c46",
  null
  
)

export default component.exports